const DESTINATIONS = [
  { id: "command", label: "Command" },
  { id: "operations", label: "Operations", capability: "automations" },
  { id: "library", label: "Library" },
  { id: "connections", label: "Connections" },
];

export function selectCommandDestinations({ automationsEnabled = false } = {}) {
  return DESTINATIONS
    .filter((destination) => !destination.capability || automationsEnabled)
    .map(({ id, label }) => ({ id, label }));
}

export function resolveCommandDestination(destination, capabilities = {}) {
  return selectCommandDestinations(capabilities)
    .some((item) => item.id === destination) ? destination : null;
}

export function selectReusableResultPresentation(outcome, { onUseResult } = {}) {
  if (!outcome) return null;
  const summary = typeof outcome.summary === "string" ? outcome.summary.trim() : "";
  const canReuse = outcome.status === "completed" && summary &&
    typeof onUseResult === "function";
  return {
    ...outcome,
    actions: canReuse
      ? [{
          id: "use-result-in-chat",
          label: "Use result in chat",
          onClick: () => onUseResult(summary),
        }]
      : [],
  };
}
